import { Component } from '@angular/core';
import { EmployeeService } from "../../../services/resources/employee.service";
import {CustomNotificationService} from "../../../services/utils/custom-notification.service";
import {MdbModalService} from "mdb-angular-ui-kit/modal";
import {MdbButtonComponent} from "../../utils/mdb-button/mdb-button.component";
import {NewEmployeeModalComponent} from "./new-employee-modal/new-employee-modal.component";
import {EmployeesTableComponent} from "./employees-table/employees-table.component";

@Component({
  selector: 'app-employees',
  imports: [ MdbButtonComponent, EmployeesTableComponent ],
  templateUrl: './employees.component.html',
  styleUrl: './employees.component.scss',
})
export class EmployeesComponent {
  constructor(
    private employeeService: EmployeeService,
    private notificationService: CustomNotificationService,
    private modalService: MdbModalService,
  ){}

  openNewEmployeeModal() {
    const modalRef = this.modalService.open(NewEmployeeModalComponent, {
      modalClass: 'modal-lg',
      ignoreBackdropClick: true,
    });
    modalRef.onClose.subscribe((employee) => {
      if (!employee)
        return;

      this.notificationService.success('EMPLOYEES.SUCCESSFULLY_CREATED');
    });
  }
}
